<div class="strength-description">
  <span class="description-label">{{ 'SIGNUP.PASS_STRENGTH' | translate }}</span>

  <span [hidden]="!(strength === low)" translate="SIGNUP.PASS_STRENGTH_LOW"></span>
  <span [hidden]="!(strength === medium)" translate="SIGNUP.PASS_STRENGTH_MEDIUM"></span>
  <span [hidden]="!(strength === high)" translate="SIGNUP.PASS_STRENGTH_STRONG"></span>
  <span [hidden]="!(strength === error)" translate="SIGNUP.PASS_STRENGTH_TOO_LONG"></span>
</div>

<mat-progress-bar
  [ngClass]="{
    low: strength === low,
    medium: strength === medium,
    high: strength === high,
    error: strength === error
  }"
  [value]="strength"></mat-progress-bar>
